<template>
  <v-row>
    <v-col class="pb-0 pt-0" cols="12" md="12">
      <v-data-table
        class="mb-4 custom-table"
        :headers="headers"
        :items-per-page="1000"
        :items="mandates"
        :loading="false"
        :hide-default-footer="true" 
      >
      <!-- custom templates -->
      <template #[`item.mandate_kind`]="{ item }">
        <el-table-enum enumName="objectType" :item="item.mandate_kind" />
      </template>
      <template #[`item.index`]="{ item, index }">
        <span>{{ formatedIndex(index) }}</span>
      </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>

export default {
   name: 'ObjectList',
   componensts: {},
   props: {
    mandates: [Array, Object]
   },
   computed: {
    headers() {
      let headers = [
        {
          text: this.$t('Eilės Nr.'),
          align: 'start',
          value: 'index',
        },
        {
          text: this.$t('Identifikavimo kodas'),
          align: 'start',
          value: 'mandate_code',
          width: '18rem',
        },
        {
          text: this.$t('Objekto rūšis'),
          align: 'start',
          value: 'mandate_kind',
        },
        {
          text: this.$t('Įregistravimo data'),
          align: 'start',
          sortable: false,
          value: 'registration_date',
        },
      ]
      return headers
    },
   },
   methods: {
    formatedIndex(index) {
      return `${index + 1}.`;
    },
   },
}
</script>
